errorMessageTemplate = require '../error_messages.html.mustache'

getSessionVariableKey = (placeId) ->
  return "mpp-tips-#{placeId}"

removeFromStorage = (placeId) ->
  sessionStorage?.removeItem getSessionVariableKey(placeId)

getFromStorage = (placeId) ->
  sessionStorage?.getItem getSessionVariableKey(placeId)

setToStorage = (placeId, value) ->
  if sessionStorage?
    sessionStorage.setItem getSessionVariableKey(placeId), value

class TipsInput

  constructor: ({ @$el, @tipSubmitter, @placeId, @tipEvents, @isMerchantSpecialTip, @userTipOwnershipModel, @minTipLength }) ->
    @$tipText = @$el.find '.tip-text'
    @$errorMessages = @$el.find '.error-messages'
    @$loading = @$el.find '.loading'
    @$shareTip = @$el.find '.share-tip'
    @$tipCounter = @$el.find '.tip-counter'
    @maxTipLength = parseInt @$tipText.attr('maxlength')

    @bindEventHandlers()

    tipText = getFromStorage @placeId
    removeFromStorage @placeId
    if tipText?.length >= @minTipLength
      @$tipText.val(tipText)
      @submitTip(true)

  bindEventHandlers: ->
    @$tipText.keyup @render
    @$shareTip.click @shareTipButtonHandler
    @userTipOwnershipModel.on('change:userHasTips', @render)

  render: =>
    if @userTipOwnershipModel.get('userHasTips')
      @disableShareButton()
    else
      @checkTipLength()

  shareTipButtonHandler: =>
    @submitTip(false)

  submitTip: (triggeredOnPageLoad = false) ->
    @hideErrors()
    @showLoading()

    text = @$tipText.val()

    @tipEvents.trigger('tipSubmitTry')

    @tipSubmitter.submitTip(
      text
      @isMerchantSpecialTip
      triggeredOnPageLoad
      success: (res) =>
        # Clear text box
        @$tipText.val ''
        @hideLoading()
        @userTipOwnershipModel.set({userHasTips: true})
        @tipEvents.trigger('tipSubmitSuccess', res)

      fail: (res) =>
        return setToStorage(@placeId, text) if MPP.JsonResponseHandler.loginRequired res
        @hideLoading()
        @showError('.profanity') if res.error?.code is 'rejected'
    )

  insertErrorMessages: ->
    return if @$errorMessages.find('.error-message').length > 0
    data = {}
    data.translate = data.t = -> (text) -> I18n.translate text
    @$errorMessages.html errorMessageTemplate.render(data)

  showError: (errorClass) ->
    @insertErrorMessages()
    @$errorMessages.find(errorClass).slideDown()

  hideErrors: ->
    @$errorMessages.find('.error-message').hide()

  checkTipLength: =>
    text = @$tipText.val().trim()
    remainingLength = @maxTipLength - text.length
    @$tipCounter.html remainingLength

    if text.length >= @minTipLength
      @enableShareButton()
    else
      @disableShareButton()

  disableShareButton: ->
    @$shareTip.prop 'disabled', true

  enableShareButton: ->
    @$shareTip.prop 'disabled', false

  showLoading: ->
    @$shareTip.hide()
    @$loading.show()

  hideLoading: ->
    @$loading.hide()
    @$shareTip.show()

Groupon.TipsInput = TipsInput
